import styled from "styled-components";

export const StyledIcon = styled.div`
  display: block;

  > svg {
    display: block;
  }
`;
